import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IImpactModuleFormData } from '../api/types/leadership';

interface IImpactModuleVLModalProps {
  isOpen: boolean;
  modalType: 'add' | 'edit';
  initialValues: IImpactModuleFormData;
}

const initialState: IImpactModuleVLModalProps = {
  isOpen: false,
  modalType: 'add',
  initialValues: {
    id: '',
    fieldValue: '',
    abbreviation: '',
  },
};

const impactModuleVLModalSlice = createSlice({
  name: 'impactModuleVLModal',
  initialState,
  reducers: {
    closeImpactModuleVLModal: () => ({
      ...initialState,
      isOpen: false,
    }),
    openAddImpactModuleVLModal: () => ({
      ...initialState,
      isOpen: true,
    }),
    openEditImpactModuleVLModal: (
      state,
      action: PayloadAction<IImpactModuleFormData>
    ) => {
      state.isOpen = true;
      state.modalType = 'edit';
      state.initialValues = {
        fieldValue: action.payload.fieldValue || '',
        id: action.payload.id || '',
        abbreviation: action.payload.abbreviation || '',
      };
    },
  },
});

export const impactModuleVLModalActions = impactModuleVLModalSlice.actions;
export const impactModuleVLModalReducer = impactModuleVLModalSlice.reducer;
